import { defineStore } from 'pinia';
import { auth } from '@/firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { fetchAccounts } from '@/api';

export default defineStore({
  id: 'session',

  state: () => ({
    user: auth.currentUser,
    accounts: [],
  }),

  getters: {},

  actions: {
    async logout() {
      await signOut(auth);
      this.user = null;
    },

    async login(params) {
      try {
        const credentials = await signInWithEmailAndPassword(
          auth,
          params.email,
          params.password
        );
        this.user = credentials.user;

        return this.user;
      } catch {
        return null;
      }
    },

    async load() {
      const accounts = await fetchAccounts();
      this.accounts = accounts;
    },

    getAccountId() {
      return this.accounts[0].type.value.accountId;
    },

    getToken() {
      return this.user?.getIdToken();
    },
  },
});
